






















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import dataService, { Device, Hardware } from '../../services/dataService'
import msg from '@/components/Msg.vue'
import { MessageText } from '@/services/data'
import UserForm from '@/views/Settings/UserForm.vue'
import ws, { SocketMsg } from '@/services/socket'
import { Route } from 'vue-router'
import TempLineChart from '@/views/Home/LineChart.vue'

@Component({
  components: {
    msg,
    UserForm,
    TempLineChart
  }
})
export default class Account extends Vue {
  isLoading = false
  device: Device = null
  message: MessageText = null
  deviceId: number
  groupInterval = 'M'
  fanGroupInterval = 'M'

  $refs: {
    tempChart: TempLineChart;
    fanChart: TempLineChart;
  }

  async mounted () {
    this.initSocket()
    this.deviceId = parseInt(this.$route.query.deviceId as string)
    await this.loadDevicesAsync()
    await this.loadChartData(this.groupInterval)
    await this.loadFanData(this.groupInterval)
  }

  async loadChartData (interval: string) {
    this.groupInterval = interval
    const properties = await dataService.getTemperatures(this.deviceId, this.groupInterval)
    if (this.$refs.tempChart) { this.$refs.tempChart.initChart(properties.Result, 'Temp ℃') }
  }

  async loadFanData (interval: string) {
    this.fanGroupInterval = interval
    const properties = await dataService.getGpuFan(this.deviceId, this.fanGroupInterval)
    if (this.$refs.fanChart) { this.$refs.fanChart.initChart(properties.Result, 'Fan Speed') }
  }

  GetHasRate (hs: number) {
    if (hs > 1000000) {
      return (hs / 1000000.0).toFixed(1)
    }
    return hs.toString()
  }

  GetAlgorithm (alg: string) {
    if (alg === 'ethash') return 'ETH'
    return alg
  }

  @Watch('$route')
  private async onRouteChange (route: Route) {
    this.deviceId = parseInt(route.query.deviceId as string)
  }

  async loadDevicesAsync () {
    const res = await dataService.getDevicesAsync(this.deviceId)
    if (res.Result && res.Result.length > 0) {
      this.device = res.Result[0]
    } else {
      await this.$alert(res.Error)
    }
  }

  GetMemoryType (hd: Hardware) {
    let type = this.GetPropertyValue(hd, 'MemoryRamType')
    if (type === '14') type = 'GDDR6'
    else if (type === '15') type = 'GDDR6X'
    const maker = this.GetPropertyValue(hd, 'MemoryRamMaker')
    if (maker === 'Not Supported') return type
    return `${maker}(${type})`
  }

  GetPropertyValue (hd: Hardware, propertyType: string, unit = '') {
    const property = hd.Properties.find(p => p.PropertyType === propertyType)
    if (property != null) {
      if (property.ValueStr) {
        if (property.ValueStr.endsWith(unit)) {
          return property.ValueStr
        } else return property.ValueStr + unit
      }
      return property.Value?.toString() + unit
    }
    return 'Not Supported'
  }

  async msgCallBack (msg: SocketMsg) {
    if (msg.Action === 'hardware-updated') {
      const clientId = msg.Content
      if (clientId === this.device?.DeviceUniqueId) {
        await this.loadDevicesAsync()
      }
    }
  }

  initSocket () {
    ws.Server.init()
    ws.Server.addMessageCallBack(this.msgCallBack)
  }

  destroyed () {
    ws.Server.removeMessageCallBack(this.msgCallBack)
    console.log('home destroyed')
  }
}
